<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../../Mixins/global'
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import FormCreator from '../../UI/Form/FormCreator.vue'
import BlockContent from '../../UI/Content/BlockContent.vue'
import FieldCreator from '../../UI/Form/FieldCreator.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import SurrenderList from '../../Surrender/SurrenderList.vue'

export default {
  components: { SurrenderList, ButtonAll, FieldCreator, BlockContent, FormCreator, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    contract: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
  },

  data: () => ({
    formData: [],
    loadForm: false,
    loadField: false,
    sending: false,
    contextEndpoint: 'def',
  }),

  emits: ['call:alert'],

  computed: {
    contractMandateView() {
      return [
        { name: 'terminateWithoutDenunciation', placeholder: false },
        { name: 'notifyAt', placeholder: true },
        { name: 'terminateReceivedAt', placeholder: true },
        { name: 'terminateAnswerAt', placeholder: true },
        { name: 'terminateConform', placeholder: false },
        { name: 'terminateComment', placeholder: true },
      ]
    },
    contractStockView() {
      return [
        { name: 'expectedRestitutionAt', placeholder: true },
        { name: 'restituteAt', placeholder: true },
        { name: 'restitutionAuditedAt', placeholder: true },
        { name: 'restituteComplete', placeholder: false },
      ]
    },
    contractCancelAndReplaceView() {
      return [
        { name: 'formerContractNumber', placeholder: true },
        { name: 'newContractNumber', placeholder: true },
      ]
    },
    contractNonRestitutionView() {
      return [
        { name: 'restitutionInvoiceNumber', placeholder: true },
        { name: 'restitutionInvoiceSentAt', placeholder: true },
      ]
    },
    contractCession() {
      return [
        { name: 'endAt', placeholder: true },
        { name: 'repurchaseAt', placeholder: true },
        { name: 'stopAt', placeholder: true },
      ]
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    setBuild(bool) {
      this.loadField = bool
    },
    objectReturn({ object, sending }) {
      this.sending = sending

      if (object) {
        this.$emit('call:alert')
      }
    },
    validate() {
      this.contextEndpoint = 'terminate'
      this.$refs.formTerminate.methods(null, null, this.specificEndpoint('terminate'))
    },
    specificEndpoint(endpoint) {
      return `${this.contract.id}/portefeuille/${endpoint}`
    },
    openModal() {
      this.loadForm = true
      this.$refs.modalContractTerminate.open()
    },
    closeModal() {
      this.loadForm = false
      this.loadField = false
      this.$refs.modalContractTerminate.close(false)
    },
  },
}
</script>
<template>
  <ModalDialog
    id="modal-contract-terminate"
    ref="modalContractTerminate"
    large
    title-t="contract.terminate.title"
    @icon-close="closeModal"
    e2e-modal="terminate"
  >
    <template #body>
      <div class="d-flex flex-wrap">
        <FormCreator
          v-if="loadForm"
          @update-data="updateData"
          ref="formTerminate"
          src-error="formTerminate"
          endpoint="contracts"
          :specific-endpoint="specificEndpoint('def')"
          method="post"
          class-to-add="d-none"
          @form-build="setBuild"
          @object-return="objectReturn"
          :disabled="readonly"
        />
        <div class="col-12 col-md-6 px-0">
          <BlockContent title-t="contract.terminate.mandateTitle" title-level="4" color="primary">
            <FieldCreator
              v-if="loadField"
              v-for="field in contractMandateView"
              :key="field.name"
              :form-data="formData"
              :name="field.name"
              form-ref="formTerminate"
              domain="contract"
              label-left-equal
              :placeholder-label="field.placeholder"
            />
            <div v-else v-for="field in contractMandateView" class="col flex-fill">
              <div class="row py-3 mb-3 mx-3 loading"></div>
            </div>
          </BlockContent>
        </div>
        <div class="col-12 col-md-6 px-0">
          <BlockContent title-t="contract.terminate.stockTitle" title-level="4" color="primary">
            <FieldCreator
              v-if="loadField"
              v-for="field in contractStockView"
              :key="field.name"
              :form-data="formData"
              :name="field.name"
              form-ref="formTerminate"
              domain="contract"
              label-left-equal
              :placeholder-label="field.placeholder"
            />
            <div v-else v-for="field in contractStockView" class="col flex-fill">
              <div class="row py-3 mb-3 mx-3 loading"></div>
            </div>
          </BlockContent>
        </div>
        <div class="col-12 col-md-6 px-0">
          <BlockContent title-t="contract.terminate.prolongationTitle" title-level="4" color="primary">
            <FieldCreator
              v-if="loadField"
              :form-data="formData"
              name="prolongationEndAt"
              form-ref="formTerminate"
              domain="contract"
              label-left-equal
              placeholder-label
            />
            <div v-else class="col flex-fill">
              <div class="row py-3 mb-3 mx-3 loading"></div>
            </div>
          </BlockContent>
        </div>
        <div class="col-12 col-md-6 px-0">
          <BlockContent title-t="contract.terminate.miscTitle" title-level="4" color="primary">
            <p class="font-weight-bold">{{ $t('contract.terminate.miscView.cancelAndReplace') }}</p>
            <FieldCreator
              v-if="loadField"
              v-for="field in contractCancelAndReplaceView"
              :key="field.name"
              :form-data="formData"
              :name="field.name"
              form-ref="formTerminate"
              domain="contract"
              label-left-equal
              :placeholder-label="field.placeholder"
            />
            <div v-else v-for="field in contractCancelAndReplaceView" class="col flex-fill">
              <div class="row py-3 mb-3 mx-3 loading"></div>
            </div>
            <p class="font-weight-bold">{{ $t('contract.terminate.miscView.nonRestitution') }}</p>
            <FieldCreator
              v-if="loadField"
              v-for="field in contractNonRestitutionView"
              :key="field.name"
              :form-data="formData"
              :name="field.name"
              form-ref="formTerminate"
              domain="contract"
              label-left-equal
              :placeholder-label="field.placeholder"
            />
            <div v-else v-for="field in contractNonRestitutionView" class="col flex-fill">
              <div class="row py-3 mb-3 mx-3 loading"></div>
            </div>
          </BlockContent>
        </div>
        <div class="col-12 px-0">
          <BlockContent title-t="contract.terminate.cessionTitle" title-level="4" color="primary">
            <FieldCreator
              v-for="field in contractCession"
              :key="field.name"
              :form-data="formData"
              :name="field.name"
              form-ref="formTerminate"
              domain="contract"
              label-left-equal
              :placeholder-label="field.placeholder"
            />
            <p class="font-weight-bold">{{ $t('contract.fields.surrender.label') }}</p>
            <SurrenderList
              v-if="loadForm"
              ref="surrenderList"
              :finance-id="contract.finance.id"
              id-modal-page="modal-contract-terminate"
            />
          </BlockContent>
        </div>
      </div>
    </template>
    <template #footer>
      <ButtonAll type="information" margin="no" label="button.cancel" @click="closeModal" />
      <ButtonAll
        type="validation"
        margin="no"
        label="button.save"
        :loading="sending"
        @click="validate"
        :disabled="readonly"
      />
    </template>
  </ModalDialog>
</template>
